import React, { useState } from "react";
import generateBase64 from "../../utils/generateBase64";
import { uploadBanner } from "../../redux/actions/currentProfileActions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import imageCompression from "browser-image-compression";

const UploadBannerForm = () => {
  const { t } = useTranslation();
  const [banner, setBanner] = useState("");
  const dispatch = useDispatch();
  const [processingImageLoading, setProcessingImageLoading] = useState(false);
  const { banner: currentBanner } = useSelector(
    (state) => state.currentProfile.data,
  );

  const handleChange = async (e) => {
    const file = e.target.files[0];

    setProcessingImageLoading(true);

    const bannerOptions = {
      maxSizeMB: 0.4, // hard cap ~150KB
      maxWidthOrHeight: 900, // smaller dimension = smaller file
      useWebWorker: true, // avoid blocking UI
      fileType: "image/webp", // more efficient format
      quality: 0.4, // visually still fine for feeds
    };

    const compressionResult = await imageCompression(file, bannerOptions);

    const compressedFile = new File([compressionResult], file.name, {
      type: "image/webp",
    });

    const formData = new FormData();
    formData.append("banner", compressedFile);
    dispatch(uploadBanner(formData));

    const base64 = await generateBase64(file);
    setBanner(base64);
  };

  return (
    <form onChange={handleChange} className="banner-upload-container">
      <input type="file" name="banner" accept="image/*" />
      {banner || currentBanner ? (
        <img
          src={banner || currentBanner}
          alt="banner"
          className="banner-image-preview"
        />
      ) : (
        <div className="banner-placeholder-ui">
          <span>{t("uploadBanner")}</span>
        </div>
      )}
      <div className="banner-edit-label">{t("Edit Banner")}</div>
    </form>
  );
  //   return (
  //     <form
  //       onChange={handleChange}
  //       className="upload-form display-flex align-items-c justify-content-se"
  //     >
  //       <input type="file" name="banner" />
  //       <div>{t("uploadBanner")}</div>
  //       {banner && <img src={banner} alt="banner" />}
  //     </form>
  //   );
};

export default UploadBannerForm;
